import { ICONS } from '@frontend/icons';
import { FormattedMessage } from 'react-intl';

export type SignInCtaIconSize = 'small' | 'big';
export type SignInCtaTheme = 'dark' | 'light';

export interface SignInCtaProps {
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    iconSize?: SignInCtaIconSize;
    theme?: SignInCtaTheme;
}

const iconSizeClasses: Record<SignInCtaIconSize, { circle: string; icon: string }> = {
    small: { circle: 'size-14', icon: 'size-6' },
    big: { circle: 'size-20', icon: 'size-10' }
};

const themeClasses: Record<SignInCtaTheme, { title: string; subtitle: string; circle: string; icon: string }> = {
    dark: {
        title: 'text-background-surface font-semibold',
        subtitle: 'text-background-surface',
        circle: 'bg-status-info',
        icon: 'text-background-surface'
    },
    light: {
        title: 'text-always-black text-base font-medium',
        subtitle: 'text-always-black',
        circle: 'bg-brand-secondary',
        icon: 'text-always-white'
    }
};

export const SignInCta = (props: SignInCtaProps) => {
    const size = props.iconSize ?? 'big';
    const classes = iconSizeClasses[size];
    const theme = themeClasses[props.theme ?? 'dark'];

    return (
        <div
            data-testid='sign-in-cta'
            className='flex flex-col items-center gap-5'>
            <div className='flex flex-col items-center justify-center gap-1'>
                <div className={`${theme.title} text-center`}>
                    {props.title ? (
                        props.title
                    ) : (
                        <FormattedMessage
                            defaultMessage='Scan your badge or code below'
                            id='kiosk.home.login.scan-your-badge-or-code-below'
                            description='Call to action shown on the home screen, prompting users to scan their badge or code to continue.'
                        />
                    )}
                </div>
                {props.subtitle && <div className={`${theme.subtitle} justify-start text-xs font-medium`}>{props.subtitle}</div>}
            </div>
            <div className={`${theme.circle} flex ${classes.circle} items-center justify-center overflow-hidden rounded-full align-middle`}>
                <ICONS.BUTTON.ARROW_DOWN className={`${theme.icon} ${classes.icon}`} />
            </div>
        </div>
    );
};

export default SignInCta;
